import * as types from './types';

export function clearInitialization() {
  return {
    type: types.CLEAR_INITIALIZATION
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/initialization/actions.js
// module id = 688
// module chunks = 49